import {  Component, Vue } from "vue-property-decorator"
import { financeBackMoneyStatisticalData, financeBackMoneyStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''

  tableData = []
  tableLoading = false

  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  souCourseName = '' //	  项目名称
  souCourseType = '' //项目种类
  souCourseSchoolBegin = [] // 开课时间
  marketCooperationName = '' // 合作伙伴名称
  marketCooperationTypes = ''// 合作方类型
  createdAt = [] // 回款时间
  backMoneyAt = [] // 回款时间
  code = '' //回款编号
  financeOrderCode = '' // 订单编号
  financeOrderCreatedUserIdList = [] // 订单创建人
  customerDirectorUserIdList = [] // 客户负责人
  createdUserIdList = [] // 回款创建人
  souCourseTypeList = commonData.projectTypeArray
  marketCooperationTypeList = [
    {label: '个人代理', val: '0'},
    {label: '机构', val: '1'},
    {label: '学校', val: '2'},
  ]
  timer = null
  backMoneyAccount = '' //收款账户
  customerName = '' // 客户名称
  payAccount = ''

  created() {
    this.getTableData()
  }

  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  //backMoneyAt: this.changeTime(this.backMoneyAt as Date[]), //回款时间


  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, financeBackMoneyList } = await financeBackMoneyStatisticalData(delNullProperty({
      souCourseName : this.souCourseName,
      souCourseTypeId : this.souCourseType,
      souCourseSchoolBegin : this.changeTime(this.souCourseSchoolBegin),
      marketCooperationName : this.marketCooperationName,
      marketCooperationTypes : this.marketCooperationTypes,
      createdAt : this.changeTime(this.createdAt),
      backMoneyAt : this.changeTime(this.backMoneyAt),
      code : this.code,
      financeOrderCode : this.financeOrderCode,
      financeOrderCreatedUserIdList : this.financeOrderCreatedUserIdList,
      createdUserIdList : this.createdUserIdList,
      account : this.backMoneyAccount,
      customerName : this.customerName,
      payAccount : this.payAccount,
      limit: this.limit,
      page: this.page,
    })) as unknown as { allNum: number; financeBackMoneyList: any[] }
    this.tableData = financeBackMoneyList
    this.total = allNum
    this.tableLoading = false

  }

  async exportExcel() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    await financeBackMoneyStatisticalDataExport(delNullProperty({
          souCourseName: this.souCourseName,
          souCourseTypeId: this.souCourseType,
          souCourseSchoolBegin: this.changeTime(this.souCourseSchoolBegin),
          marketCooperationName: this.marketCooperationName,
          marketCooperationTypes: this.marketCooperationTypes,
          createdAt: this.changeTime(this.createdAt),
          backMoneyAt: this.changeTime(this.backMoneyAt),
          code: this.code,
          financeOrderCode: this.financeOrderCode,
          financeOrderCreatedUserIdList: this.financeOrderCreatedUserIdList,
          createdUserIdList: this.createdUserIdList,
          customerName: this.customerName,
          account: this.backMoneyAccount,
          payAccount: this.payAccount,
        })
    ).finally(() => {
      this.exportButtonDisabled = false
    })
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  changeCreatedUserIdList(e) {
    this.createdUserIdList = e.id
    this.page = 1
    this.getTableData()
  }
  changeFinanceOrderCreatedUserIdList(e) {
    this.financeOrderCreatedUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

}
